declare type PathBookingsList = 'Bookings' | 'GetByFilter' | 'GetFlightCreditByFilter';
declare type PathBookings = 'Booking' | 'GetDetails';

export const EnabledPathsBookingsList: Record<PathBookingsList, PathBookingsList> = {
  Bookings: 'Bookings',
  GetByFilter: 'GetByFilter',
  GetFlightCreditByFilter: 'GetFlightCreditByFilter'
};

export const PathBookingManager: Record<PathBookings, PathBookings> = {
  Booking: 'Booking',
  GetDetails: 'GetDetails'
};
